import { all, call, put, take } from 'redux-saga/effects';
import { LOAD_PREFERRED_SITE_LIST } from '../type';
import {
  loadPreferredSiteListSuccessAction,
  loadPreferredSiteListErrorAction,
} from '../action';

import { preferredSiteService } from 'services';

function* loadPreferredSiteList() {
  while (1) {
    const action = yield take(LOAD_PREFERRED_SITE_LIST);
    try {
      const preferredSiteList = yield call(
        preferredSiteService.loadPreferredSiteList,
        action.payload,
      );
      yield put(loadPreferredSiteListSuccessAction(preferredSiteList));
    } catch (err) {
      yield put(loadPreferredSiteListErrorAction(err));
    }
  }
}

export default function* rootSaga() {
  yield all([loadPreferredSiteList()]);
}
